'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, range, metricKey, mainScale) {
  /**
   * In case when there's no d.m3 or d.m4 use zero (ex. postDepartureMode)
   * @param d
   * @returns {Array}
   */
  var yMin = d3.min(data, function (d) {
    var values = [0];
    if (_.isArray(metricKey)) {
      _.forEach(metricKey, function (metric) {
        values.push(d[metric]);
      });
    } else {
      values.push(d[metricKey]);
    }
    return _.min(_.without(values, undefined));
  });
  var yMax = d3.max(data, function (d) {
    var values = [0];
    if (_.isArray(metricKey)) {
      _.forEach(metricKey, function (metric) {
        values.push(d[metric]);
      });
    } else {
      values.push(d[metricKey]);
    }
    return _.max(_.without(values, undefined));
  });
  if (mainScale) {
    var mainScaleDomain = mainScale.yScale.domain();
    var mainYMax = mainScaleDomain[1];
    var mainYMin = mainScaleDomain[0];
    if (mainYMax !== 0) {
      yMin = mainYMin * yMax / mainYMax;
    }
  }

  // the brush can modify the visible range of elements
  data = data.slice(range[0], range[1]);
  var x = d3.scale.ordinal().domain(_.map(data, 'departureDateMoment')).rangeBands([0, params.width], 0.1, 0.05);
  var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;